if (!customElements.get('swiper-component')) {
    class SwiperComponent extends HTMLElement {

        constructor() {
            super();
            this.swiperButtons = this.querySelector('[data-swiper-buttons]');
            this.swiperButtonPrev = this.querySelector('[data-swiper-button-prev]');
            this.swiperButtonNext = this.querySelector('[data-swiper-button-next]');
            this.settings = {
                direction: 'horizontal',
                slidesPerView: 2,
                spaceBetween: 20,
                speed: 400,
                loop: false,
                init: false,
                navigation: {
                    prevEl: this.swiperButtonPrev,
                    nextEl: this.swiperButtonNext
                },
                breakpoints: {
                    0: {
                        slidesPerView: 2,
                        spaceBetween: 12
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 14
                    },
                    1440: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    }
                }
            }
            Object.keys(this.settings.breakpoints).forEach(key => {
                key = parseFloat(key);
                if (window.innerWidth > key) {
                    this.currentBreakpoint = this.settings.breakpoints[key];
                }
            });
            if (this.hasAttribute('data-collection-products')) {
                this.productSize = parseFloat(this.getAttribute('data-collection-products'));
            }
        }

        connectedCallback() {

            /**
             * Load virtual skeleton slides if no collection products from liquid are present
             */
            if (this.hasAttribute('data-skus')) {
                this.settings.virtual = {
                    slides: ( () => Array.from({length: 3}).map(()=> `<div class="skeleton-product-card"></div>`))(),
                    cache: false
                }
            }

            this.swiper = new Swiper(this, this.settings);
            
            if (this.productSize <= this.currentBreakpoint.slidesPerView) {
                this.swiper.params.preventClicks = false;
                this.swiper.preventClicks = false;
                this.swiper.params.preventClicksPropagation = false;
                this.swiper.preventClicksPropagation = false;
                this.swiperButtons.setAttribute('hidden', '');
            }

            this.swiper.init();

            /**
             * Fetch SKU Products from data-attribute
             */
            if (this.hasAttribute('data-skus')) {
                this.fetchSKUS(this.getAttribute('data-skus'));
            }

        }

        fetchSKUS(skus) {
            let splittedSkus = { part1: [], part2: [] };
            try {
                var skus_default = JSON.parse(skus).map(sku => sku.toString().toLowerCase())
                skus = JSON.parse(skus);
                if (skus.length > 50) {
                    skus.forEach((sku,i) => {
                        if (i <= 49) {
                            splittedSkus.part1.push(sku);
                        } else {
                            splittedSkus.part2.push(sku);
                        }
                    });
                }
                if (skus.length <= 50) {
                    skus = Shopify.formatSkusForSearch(skus);
                    let url;
                    if(this.hasAttribute('data-locale')) {
                        url = new URL(`${window.location.origin}/${this.getAttribute('data-locale')}/search`);
                    } else {
                        url = new URL(`${window.location.origin}/search`);
                    }
                    url.search = new URLSearchParams({ q: skus.join(' OR '), type: "product", view: `sku` }).toString();
                    fetch(url).then(r => r.json()).then(r => this.parseResults(r, skus_default));
                } else if (skus.length > 50) {
                    splittedSkus.part1 = Shopify.formatSkusForSearch(splittedSkus.part1);
                    splittedSkus.part2 = Shopify.formatSkusForSearch(splittedSkus.part2);
                    if(this.hasAttribute('data-locale')) {
                        splittedSkus.url1 = new URL(`${window.location.origin}/${this.getAttribute('data-locale')}/search`);
                        splittedSkus.url2 = new URL(`${window.location.origin}/${this.getAttribute('data-locale')}/search`);
                    } else {
                        splittedSkus.url1 = new URL(`${window.location.origin}/search`);
                        splittedSkus.url2 = new URL(`${window.location.origin}/search`);
                    }
                    splittedSkus.url1.search = new URLSearchParams({ q: splittedSkus.part1.join(' OR '), type: "product", view: `sku` }).toString();
                    splittedSkus.url2.search = new URLSearchParams({ q: splittedSkus.part2.join(' OR '), type: "product", view: `sku` }).toString();
                    fetch(splittedSkus.url1)
                        .then(r => r.json())
                        .then(r => splittedSkus.result1 = r)
                        .then(() => fetch(splittedSkus.url2)
                                        .then(r => r.json())
                                        .then(r => splittedSkus.result2 = r)
                        )
                        .then(() => {
                            this.parseResults({
                                results: [
                                    ...splittedSkus.result1.results,
                                    ...splittedSkus.result2.results
                                ],
                                results_count: splittedSkus.result1.results_count + splittedSkus.result2.results_count
                            }, skus_default)
                        });
                }
            } catch (error) {
                console.log(error)
            }
        }

        /**
         * 
         * Interprets the result of the search fetch and replaces all virtual skeleton loading slides of swiper
         * 
         * @param {Object} r 
         */
        parseResults(r, skus_default) {
            if (r && r.results_count > 0) {
                const slides = [];
                r.results.forEach(product => {
                    const slideHtml = new DOMParser().parseFromString(product.cardHtml, 'text/html').querySelector('body').innerHTML;
                    var extracted_sku = this.extractSkuFromCardHtml(product.cardHtml);
                    if(extracted_sku && skus_default.includes(extracted_sku)){
                      slides.push(slideHtml);
                    }
                });
                this.swiper.virtual.slides = slides;
                if (slides.length <= this.currentBreakpoint.slidesPerView) {
                    this.swiper.params.preventClicks = false;
                    this.swiper.preventClicks = false;
                    this.swiper.params.preventClicksPropagation = false;
                    this.swiper.preventClicksPropagation = false;
                    this.swiperButtons.setAttribute('hidden', '');
                }
                this.swiper.virtual.update(true);
                if (this.hasAttribute('data-type-xsell')) {
                    this.querySelectorAll('.product-card-available-sizes').forEach(el => el.remove());
                }
            } else {
                this.closest('.shopify-section').remove();
            }
        }

        extractSkuFromCardHtml(str){
          var extracted_sku = str.match(/parent\-sku\-\-(.*?)[\"\s\\]/s);
          return extracted_sku && extracted_sku[1].toLowerCase();
        }

    }
    
    customElements.define('swiper-component', SwiperComponent);

}
  